export default {
      id: "i-phone-usage",
      viewBox: "0 0 43 43",
      url: __webpack_public_path__ + "img/sprite.svg#i-phone",
      toString: function () {
        return this.url;
      }
    }